/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type salesBalanceTimeseriesQueryVariables = {};
export type salesBalanceTimeseriesQueryResponse = {
  readonly invsysSalesBalanceTimeseries: ReadonlyArray<{
    readonly institution: number;
    readonly institutionIssuedId: string;
    readonly thisWeekPoints: ReadonlyArray<{
      readonly at: number;
      readonly value: number;
    }>;
    readonly thisWeekAggregationBucket: number;
    readonly lastWeekTotal: number;
    readonly thisMonthPoints: ReadonlyArray<{
      readonly at: number;
      readonly value: number;
    }>;
    readonly thisMonthAggregationBucket: number;
    readonly lastMonthTotal: number;
    readonly thisYearPoints: ReadonlyArray<{
      readonly at: number;
      readonly value: number;
    }>;
    readonly thisYearAggregationBucket: number;
    readonly lastYearTotal: number;
    readonly allTimePoints: ReadonlyArray<{
      readonly at: number;
      readonly value: number;
    }>;
    readonly allTimeAggregationBucket: number;
  }>;
};
export type salesBalanceTimeseriesQuery = {
  readonly response: salesBalanceTimeseriesQueryResponse;
  readonly variables: salesBalanceTimeseriesQueryVariables;
};

/*
query salesBalanceTimeseriesQuery {
  invsysSalesBalanceTimeseries {
    institution
    institutionIssuedId
    thisWeekPoints {
      at
      value
    }
    thisWeekAggregationBucket
    lastWeekTotal
    thisMonthPoints {
      at
      value
    }
    thisMonthAggregationBucket
    lastMonthTotal
    thisYearPoints {
      at
      value
    }
    thisYearAggregationBucket
    lastYearTotal
    allTimePoints {
      at
      value
    }
    allTimeAggregationBucket
  }
}
*/

const node: ConcreteRequest = (function () {
  var v0 = [
      {
        alias: null,
        args: null,
        kind: 'ScalarField',
        name: 'at',
        storageKey: null,
      },
      {
        alias: null,
        args: null,
        kind: 'ScalarField',
        name: 'value',
        storageKey: null,
      },
    ],
    v1 = [
      {
        alias: null,
        args: null,
        concreteType: 'InvsysSalesBalanceTimeseriesBreakdown',
        kind: 'LinkedField',
        name: 'invsysSalesBalanceTimeseries',
        plural: true,
        selections: [
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'institution',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'institutionIssuedId',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            concreteType: 'InvsysTimeseriesPoint',
            kind: 'LinkedField',
            name: 'thisWeekPoints',
            plural: true,
            selections: v0 /*: any*/,
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'thisWeekAggregationBucket',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'lastWeekTotal',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            concreteType: 'InvsysTimeseriesPoint',
            kind: 'LinkedField',
            name: 'thisMonthPoints',
            plural: true,
            selections: v0 /*: any*/,
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'thisMonthAggregationBucket',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'lastMonthTotal',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            concreteType: 'InvsysTimeseriesPoint',
            kind: 'LinkedField',
            name: 'thisYearPoints',
            plural: true,
            selections: v0 /*: any*/,
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'thisYearAggregationBucket',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'lastYearTotal',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            concreteType: 'InvsysTimeseriesPoint',
            kind: 'LinkedField',
            name: 'allTimePoints',
            plural: true,
            selections: v0 /*: any*/,
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'allTimeAggregationBucket',
            storageKey: null,
          },
        ],
        storageKey: null,
      },
    ];
  return {
    fragment: {
      argumentDefinitions: [],
      kind: 'Fragment',
      metadata: null,
      name: 'salesBalanceTimeseriesQuery',
      selections: v1 /*: any*/,
      type: 'Query',
      abstractKey: null,
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: [],
      kind: 'Operation',
      name: 'salesBalanceTimeseriesQuery',
      selections: v1 /*: any*/,
    },
    params: {
      cacheID: 'ffad3c346b8bc214e8c8633b56251bb9',
      id: null,
      metadata: {},
      name: 'salesBalanceTimeseriesQuery',
      operationKind: 'query',
      text: 'query salesBalanceTimeseriesQuery {\n  invsysSalesBalanceTimeseries {\n    institution\n    institutionIssuedId\n    thisWeekPoints {\n      at\n      value\n    }\n    thisWeekAggregationBucket\n    lastWeekTotal\n    thisMonthPoints {\n      at\n      value\n    }\n    thisMonthAggregationBucket\n    lastMonthTotal\n    thisYearPoints {\n      at\n      value\n    }\n    thisYearAggregationBucket\n    lastYearTotal\n    allTimePoints {\n      at\n      value\n    }\n    allTimeAggregationBucket\n  }\n}\n',
    },
  };
})();
(node as any).hash = 'eaa04c703ab1987236349a9f96c03d4c';
export default node;
